import { Trans } from '~/common/context';
import { useManageRedistributionBrandTemplates } from '~/connect/api';
import { BaseCustomerBrandsForm } from '~/connect/components';
import { CustomerUtils } from '~/connect/helpers';
import { CustomerFormProps } from '~/connect/hooks';

const RedistributionBrandsForm = ({
  forms,
  internalCriteria,
}: CustomerFormProps) => {
  const watchedCriteria =
    forms[CustomerUtils.CRITERIA_STEP].methods.watch('criteria');
  const hasSelectedCriteria =
    watchedCriteria.length > 0 &&
    watchedCriteria.every(
      (criterion) => criterion.criterion.id && criterion.value,
    );

  const manageRedistributionBrandTemplates =
    useManageRedistributionBrandTemplates({
      getMatched: {
        enabled: hasSelectedCriteria,
        args: {
          customerCriteria: watchedCriteria.map(({ criterion, value }) => ({
            id: criterion.id,
            valueId: value,
          })),
          customerInternalCriteria: internalCriteria,
        },
      },
    });

  return (
    <BaseCustomerBrandsForm
      isLoading={manageRedistributionBrandTemplates.getMatched.isFetching}
      brandTemplateLabel={
        <Trans i18nKey='app.entity.tab.redistribution_brands' />
      }
      matchedBrandTemplate={
        manageRedistributionBrandTemplates.getMatched.data?.data
      }
    />
  );
};

export default RedistributionBrandsForm;
